var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'font-meiryoui--app': _vm.jaFont }},[_c('TheMobileNav'),_vm._v(" "),_c('TheHeader'),_vm._v(" "),_c('v-content',{staticClass:"page-content",attrs:{"id":"scrolling"}},[_c('nuxt')],1),_vm._v(" "),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }